/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/creditMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Credit. */
export class Credit {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Credit.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves an auth cookie that can be used to access protected CM APIs.
   * @summary Retrieves a sensitve access auth cookie for web.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  getAuthCookie(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  getAuthCookie(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAuthCookie(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  getAuthCookie(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAuthCookieOperationSpec,
      callback);
  }

  /**
   * Retrieves an auth cookie that can be used to access protected CM APIs.
   * @summary Retrieves a sensitve access auth cookie for WebView.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  getWebViewAuthCookie(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  getWebViewAuthCookie(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getWebViewAuthCookie(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  getWebViewAuthCookie(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getWebViewAuthCookieOperationSpec,
      callback);
  }

  /**
   * Refreshes an auth cookie that can be used to access protected CM APIs.
   * @summary Refreshes a sensitve access auth cookie.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  refreshAuthCookie(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  refreshAuthCookie(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  refreshAuthCookie(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  refreshAuthCookie(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      refreshAuthCookieOperationSpec,
      callback);
  }

  /**
   * Retrieves the credit summary for the current user.
   * @summary Retrieves the credit summary for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.CreditGetCreditSummaryResponse>
   */
  getCreditSummary(options?: coreHttp.RequestOptionsBase): Promise<Models.CreditGetCreditSummaryResponse>;
  /**
   * @param callback The callback
   */
  getCreditSummary(callback: coreHttp.ServiceCallback<Models.CreditSummary>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getCreditSummary(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.CreditSummary>): void;
  getCreditSummary(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.CreditSummary>, callback?: coreHttp.ServiceCallback<Models.CreditSummary>): Promise<Models.CreditGetCreditSummaryResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getCreditSummaryOperationSpec,
      callback) as Promise<Models.CreditGetCreditSummaryResponse>;
  }

  /**
   * Update the credit monitoring alert for the current user.
   * @summary Update the credit monitoring alert for the current user.
   * @param id
   * @param [options] The optional parameters
   * @returns Promise<Models.CreditUpdateCreditMonitoringAlertResponse>
   */
  updateCreditMonitoringAlert(id: string, options?: Models.CreditUpdateCreditMonitoringAlertOptionalParams): Promise<Models.CreditUpdateCreditMonitoringAlertResponse>;
  /**
   * @param id
   * @param callback The callback
   */
  updateCreditMonitoringAlert(id: string, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  /**
   * @param id
   * @param options The optional parameters
   * @param callback The callback
   */
  updateCreditMonitoringAlert(id: string, options: Models.CreditUpdateCreditMonitoringAlertOptionalParams, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  updateCreditMonitoringAlert(id: string, options?: Models.CreditUpdateCreditMonitoringAlertOptionalParams | coreHttp.ServiceCallback<Models.CreditAlert>, callback?: coreHttp.ServiceCallback<Models.CreditAlert>): Promise<Models.CreditUpdateCreditMonitoringAlertResponse> {
    return this.client.sendOperationRequest(
      {
        id,
        options
      },
      updateCreditMonitoringAlertOperationSpec,
      callback) as Promise<Models.CreditUpdateCreditMonitoringAlertResponse>;
  }

  /**
   * Retrieves the credit alert for the current user.
   * @summary Retrieves the credit alert for the current user.
   * @param id
   * @param [options] The optional parameters
   * @returns Promise<Models.CreditGetCreditAlertByIdResponse>
   */
  getCreditAlertById(id: string, options?: coreHttp.RequestOptionsBase): Promise<Models.CreditGetCreditAlertByIdResponse>;
  /**
   * @param id
   * @param callback The callback
   */
  getCreditAlertById(id: string, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  /**
   * @param id
   * @param options The optional parameters
   * @param callback The callback
   */
  getCreditAlertById(id: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  getCreditAlertById(id: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.CreditAlert>, callback?: coreHttp.ServiceCallback<Models.CreditAlert>): Promise<Models.CreditGetCreditAlertByIdResponse> {
    return this.client.sendOperationRequest(
      {
        id,
        options
      },
      getCreditAlertByIdOperationSpec,
      callback) as Promise<Models.CreditGetCreditAlertByIdResponse>;
  }

  /**
   * Retrieves the dictionary mapping of all static recommendations for the current user.
   * @summary Retrieves all recommendation mappings for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.CreditGetAllRecommendationMappingsResponse>
   */
  getAllRecommendationMappings(options?: coreHttp.RequestOptionsBase): Promise<Models.CreditGetAllRecommendationMappingsResponse>;
  /**
   * @param callback The callback
   */
  getAllRecommendationMappings(callback: coreHttp.ServiceCallback<Models.Pathsrtx3obapiV1MeCreditAlertsRecommendationsgetresponses200contenttextPlainschema>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAllRecommendationMappings(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.Pathsrtx3obapiV1MeCreditAlertsRecommendationsgetresponses200contenttextPlainschema>): void;
  getAllRecommendationMappings(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.Pathsrtx3obapiV1MeCreditAlertsRecommendationsgetresponses200contenttextPlainschema>, callback?: coreHttp.ServiceCallback<Models.Pathsrtx3obapiV1MeCreditAlertsRecommendationsgetresponses200contenttextPlainschema>): Promise<Models.CreditGetAllRecommendationMappingsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAllRecommendationMappingsOperationSpec,
      callback) as Promise<Models.CreditGetAllRecommendationMappingsResponse>;
  }

  /**
   * Mark a recommendation as completed by setting the isCompleted flag of the recommendation to
   * true.
   * @summary Complete a recommendation.
   * @param alertId
   * @param recommendationId Possible values include: 'SigninToAccountAndCheckDetails',
   * 'CheckJointOwnerOfCardOrAccount', 'ContactCreditorForMoreInformation',
   * 'StillDontRecognizeActivityFileDisputeWithExperian', 'FileADisputeWithExperian',
   * 'AppliedOrCosignedForNewServiceAccountOrLoan',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation', 'ContactInquirerByMail',
   * 'ContactInquirerCompany', 'ContactIdentityValidatorCompany', 'ContactCompanyForMoreInformation',
   * 'SSNTrace', 'CreditFileLocked', 'CreditFileUnlocked', 'CreditFileUnlockedDueToMembershipChange',
   * 'InquiryBlocked', 'ContactExperianCreditLockStatus',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity'
   * @param [options] The optional parameters
   * @returns Promise<Models.CreditCompleteRecommendationResponse>
   */
  completeRecommendation(alertId: string, recommendationId: Models.CreditRecommendationType, options?: Models.CreditCompleteRecommendationOptionalParams): Promise<Models.CreditCompleteRecommendationResponse>;
  /**
   * @param alertId
   * @param recommendationId Possible values include: 'SigninToAccountAndCheckDetails',
   * 'CheckJointOwnerOfCardOrAccount', 'ContactCreditorForMoreInformation',
   * 'StillDontRecognizeActivityFileDisputeWithExperian', 'FileADisputeWithExperian',
   * 'AppliedOrCosignedForNewServiceAccountOrLoan',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation', 'ContactInquirerByMail',
   * 'ContactInquirerCompany', 'ContactIdentityValidatorCompany', 'ContactCompanyForMoreInformation',
   * 'SSNTrace', 'CreditFileLocked', 'CreditFileUnlocked', 'CreditFileUnlockedDueToMembershipChange',
   * 'InquiryBlocked', 'ContactExperianCreditLockStatus',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity'
   * @param callback The callback
   */
  completeRecommendation(alertId: string, recommendationId: Models.CreditRecommendationType, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  /**
   * @param alertId
   * @param recommendationId Possible values include: 'SigninToAccountAndCheckDetails',
   * 'CheckJointOwnerOfCardOrAccount', 'ContactCreditorForMoreInformation',
   * 'StillDontRecognizeActivityFileDisputeWithExperian', 'FileADisputeWithExperian',
   * 'AppliedOrCosignedForNewServiceAccountOrLoan',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation', 'ContactInquirerByMail',
   * 'ContactInquirerCompany', 'ContactIdentityValidatorCompany', 'ContactCompanyForMoreInformation',
   * 'SSNTrace', 'CreditFileLocked', 'CreditFileUnlocked', 'CreditFileUnlockedDueToMembershipChange',
   * 'InquiryBlocked', 'ContactExperianCreditLockStatus',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity'
   * @param options The optional parameters
   * @param callback The callback
   */
  completeRecommendation(alertId: string, recommendationId: Models.CreditRecommendationType, options: Models.CreditCompleteRecommendationOptionalParams, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  completeRecommendation(alertId: string, recommendationId: Models.CreditRecommendationType, options?: Models.CreditCompleteRecommendationOptionalParams | coreHttp.ServiceCallback<Models.CreditAlert>, callback?: coreHttp.ServiceCallback<Models.CreditAlert>): Promise<Models.CreditCompleteRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        alertId,
        recommendationId,
        options
      },
      completeRecommendationOperationSpec,
      callback) as Promise<Models.CreditCompleteRecommendationResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getAuthCookieOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/credit/webtoken",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getWebViewAuthCookieOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/credit/webviewtoken",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const refreshAuthCookieOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/credit/refreshtoken",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getCreditSummaryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/credit/summary",
  responses: {
    200: {
      bodyMapper: Mappers.CreditSummary
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateCreditMonitoringAlertOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/credit/alerts/{id}",
  urlParameters: [
    Parameters.id
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.CreditAlertRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.CreditAlert
    },
    404: {
      bodyMapper: Mappers.CreditAlert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getCreditAlertByIdOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/credit/alerts/{id}",
  urlParameters: [
    Parameters.id
  ],
  responses: {
    200: {
      bodyMapper: Mappers.CreditAlert
    },
    404: {
      bodyMapper: Mappers.CreditAlert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getAllRecommendationMappingsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/credit/alerts/recommendations",
  responses: {
    200: {
      bodyMapper: Mappers.Pathsrtx3obapiV1MeCreditAlertsRecommendationsgetresponses200contenttextPlainschema
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const completeRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/credit/alerts/{alertId}/{recommendationId}",
  urlParameters: [
    Parameters.alertId,
    Parameters.recommendationId1
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ResolveRecommendationRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.CreditAlert
    },
    404: {
      bodyMapper: Mappers.CreditAlert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
